import PropTypes from 'prop-types'
import { useEffect, useRef, useState } from 'react'
import { debounce } from '../../../helpers/common'
import { Element } from '../../html/element'
import classes from './index.module.scss'
import { Item } from './Item'
import { More } from './More'

export const Horizontal = ({ list }) => {
  const [data, setData] = useState(list)
  const [moreData, setMoreData] = useState([])
  const [widths, setWidths] = useState({})
  const parentRef = useRef()

  useEffect(() => {
    setDataAndMoreData()
  }, [widths])

  useEffect(() => {
    const resize = debounce(() => {
      setDataAndMoreData()
    }, 100)
    window.addEventListener('resize', resize)

    return () => window.removeEventListener('resize', resize)
  }, [widths])

  const getIndexOfItemRightGreaterThanParent = (widths, parentWidth) => {
    let result = Object.keys(widths).length
    let widthSum = 0
    const OFFSET_MORE_BUTTON = 48
    Object.keys(widths).forEach((key, index) => {
      widthSum += widths[key]
      if (widthSum + OFFSET_MORE_BUTTON > parentWidth) {
        result = Math.min(result, index)
      }
    })

    return result
  }

  const setDataAndMoreData = () => {
    if (Object.keys(widths).length > 0) {
      const parentWidth = parentRef.current?.clientWidth || 0
      const indexOfItemRightGrThParent = getIndexOfItemRightGreaterThanParent(
        widths,
        parentWidth,
      )

      const newData = []
      const newMoreData = []
      for (let index = 0; index < Object.keys(widths).length; index++) {
        const item = list[index]

        if (index >= indexOfItemRightGrThParent) {
          newMoreData.push(item)
        } else {
          newData.push(item)
        }
      }

      setData(newData)
      setMoreData(newMoreData)
    }
  }

  return (
    <Element
      ref={parentRef}
      elementName="ul"
      className={classes.container}
      style={{ backgroundColor: '#EBEBEB', whiteSpace: 'nowrap' }}
    >
      {data.map(
        (
          { route, label, children, isI18n, isLock, keepQueryStrParams },
          index,
        ) => {
          return (
            <Item
              key={index}
              route={route}
              keepQueryStrParams={keepQueryStrParams}
              label={label}
              children={children}
              isI18n={isI18n}
              isLock={isLock}
              setWidths={setWidths}
              isBorderLeft={index !== 0}
            />
          )
        },
      )}
      {moreData.length > 0 && <More data={moreData} />}
    </Element>
  )
}

Horizontal.propTypes = {
  list: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      isI18n: PropTypes.bool,
      route: PropTypes.string,
      keepQueryStrParams: PropTypes.arrayOf(PropTypes.string),
    }),
  ).isRequired,
  isChildren: PropTypes.bool,
}
